import { cn } from "@/lib/utils";
import React from "react";

interface IconProps extends React.ComponentProps<"span"> {
    name: string;
}

export function Icon({ name, className, ...props }: IconProps) {
    return (
        <span className={cn("material-symbols", className)} {...props}>
            {name}
        </span>
    );
}
